import { useMemo } from 'react'
import { useApp } from 'store/steps'
import Text from 'components/shared/Text'
import Checkbox from 'components/shared/Checkbox'
import { Option } from 'components/shared/MultiSelect'

interface MultiSelectCheckboxProps {
    option: Option
    index: number
    isChecked: boolean
    toggleChecked: () => void
    isFocusable: boolean
}

const MultiSelectCheckbox = ({
    option,
    index,
    isChecked,
    toggleChecked,
    isFocusable,
}: MultiSelectCheckboxProps) => {
    const { language } = useApp()
    const { id, pl, en, uk } = option

    const localizedOptions = useMemo(() => {
        switch (language) {
            case 'uk':
                return uk
            case 'en':
                return en
            case 'pl':
            default:
                return pl
        }
    }, [language])

    return (
        <Checkbox
            isChecked={isChecked}
            setIsChecked={toggleChecked}
            key={`checkbox-${id}`}
            testId={`payment-check-mandatory-regulations-${index}`}
            isFocusable={isFocusable}
        >
            <Text variant="bodySmall" color="grayscale_900">
                {localizedOptions}
            </Text>
        </Checkbox>
    )
}

export default MultiSelectCheckbox
